export { default } from './Base/Tooltip';
